import axios from 'axios';
import Cookies from 'js-cookie';

import { API_ROUTES, MARKETO } from '../../../constants';

/**
 * Gets utm cookie values and applies them to fields
 *
 * @param fields
 * @returns {{}|*}
 */
export const getUTMvalues = (fields = [], skipFieldCheck = false) => {
  const utmCookie = Cookies.get(MARKETO.UTM_COOKIE);
  if (!utmCookie) {
    return {};
  }
  let utmValues = {};
  let utmSplit = utmCookie.split('|');

  utmSplit.forEach((utm) => {
    let split = utm.split('=');
    let fieldExists;
    if (split && split[0]) {
      fieldExists = fields?.filter((f) => f.name?.toLowerCase() === split[0]?.toLowerCase())?.[0];
    }
    if (fieldExists || skipFieldCheck) {
      utmValues[split[0]] = split[1];
    }
  });
  return utmValues;
};

/**
 * Submits any form created in Marketo and built with the Dynamic Form Builder
 *
 * @param fields The array of fields provided by Marketo
 * @param values The entered form values on submission
 * @param programName The Marketo program name associated with the form.
 * @param email Hack to submit known email with secondary forms to prevent "Unknown" users in marketo
 * @returns {boolean} Success or not
 */
export const submitGenericForm = async (fields, values, programName, email, captchaToken) => {
  // Gather UTM values from cookies
  const utmValues = getUTMvalues(fields);
  let combined = { ...values, ...utmValues };
  if (email && !combined.Email) {
    combined.Email = email;
  }
  // Remove invalid fields + fix checkbox group fields
  for (const key in combined) {
    if (!key || key === 'undefined') {
      delete combined[key];
    }
    if (Array.isArray(combined[key])) {
      combined[key] = combined[key].join(';');
    }
  }

  const payload = {
    programName,
    fields: combined,
    munchkinId: Cookies.get(MARKETO.MUNCHKIN_COOKIE),
    captchaToken,
  };

  try {
    const success = await axios.post(API_ROUTES.CREATE_LEAD, payload);
    return { success };
  } catch (e) {
    return false;
  }
};

export const submitSuccessEvents = ({
  eventName = 'successful_demo_submission',
  eventData = {},
  formId = null,
  values = {},
  programName,
}) => {
  if (typeof window === 'undefined') {
    return;
  }
  const consent = window.Osano?.cm?.getConsent();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'formSubmission',
    formID: formId,
    programName,
  });

  if (window.FS) {
    window.FS.event('Marketo Form', {
      type: 'Form was successful',
      formID: formId?.toString(),
    });
  }

  if (consent?.MARKETING === 'ACCEPT') {
    if (!!window._6si) {
      try {
        window._6si.push(['sendFormData', values]);
      } catch (e) {
        console.log(`Error submitting to 6si: ${e}`);
      }
    }
  }
  return null;
};
